import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { Box as MuiBox } from '@mui/material';
import merchants from "../models/merchants";
import useRootHook from "../hooks/useRoot";
import {useNavigate, useSearchParams} from "react-router-dom";
import {useEffect} from "react";
import admins from "../models/admins";
import referrals from "../models/referrals";
import helpers from "../helpers/common";

export const TYPE_KEY = 'lt'
export const TYPE_ADMIN = 'a'
export const TYPE_MANAGER = 'm'
export const TYPE_REFERRAL = 'r'
export const ADMIN_PATH = '/admin'
export const REFERRAL_PATH = '/referral'

export default function Login() {
    const {authed, setAuthed, setUserData, setShowLoader, notify, setDefaultCurrency} = useRootHook();
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const pathname = window.location.pathname
    
    // Determine login type: admin, referral, or merchant
    let type = TYPE_MANAGER
    if (pathname.includes('/admin')) {
        type = TYPE_ADMIN
    } else if (pathname.includes('/referral') || searchParams.get('type') === 'referral') {
        type = TYPE_REFERRAL
    }

    useEffect(() => {
        if (authed) {
            navigate('/')
        }
    }, [authed])

    const handleSubmit = (event) => {
        event.preventDefault();
        setShowLoader(true)
        const data = new FormData(event.currentTarget);
        let loginModel;
        if (type === TYPE_ADMIN) {
            loginModel = admins;
        } else if (type === TYPE_REFERRAL) {
            loginModel = referrals;
        } else {
            loginModel = merchants;
        }
        
        const username = data.get('email') || data.get('username');
        loginModel.login(username, data.get('password'))
            .then((result) => {
                setShowLoader(false)
                result && result.username && setUserData(result)
                result && result.username && setAuthed(true)
                result && result.defaultCurrency && setDefaultCurrency(result.defaultCurrency)
                notify(`Welcome back ${result.username}`, 3000)
                localStorage.setItem(TYPE_KEY, type)
                if (type === TYPE_ADMIN || type === TYPE_REFERRAL) {
                    navigate('/')
                }
            }).catch(() => setShowLoader(false))
    };

    return (
            <Container component="main" maxWidth="xs">
                <CssBaseline />
                <MuiBox
                    sx={{
                        marginTop: 8,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Sign in {type === TYPE_REFERRAL ? '(Referral)' : type === TYPE_ADMIN ? '(Admin)' : '(Merchant)'}
                    </Typography>
                    <MuiBox component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id={type === TYPE_REFERRAL ? "username" : "email"}
                            label={type === TYPE_REFERRAL ? "Username" : "Email Address"}
                            name={type === TYPE_REFERRAL ? "username" : "email"}
                            autoComplete={type === TYPE_REFERRAL ? "username" : "email"}
                            autoFocus
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="Password"
                            type="password"
                            id="password"
                            autoComplete="current-password"
                        />
                        {/*{<FormControlLabel
                            control={<Checkbox name="remember" value="remember" color="primary" />}
                            label="Remember me"
                        />}*/}
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2 }}
                        >
                            Sign In
                        </Button>
                        <Grid container>
                            {/*<Grid item xs>
                                <Link to={forgotPasswordLink} variant="body2" component={RouterLink}>
                                    Forgot password?
                                </Link>
                            </Grid>*/}
                            {/*<Grid item>
                                <Link href="#" variant="body2">
                                    {"Don't have an account? Sign Up"}
                                </Link>
                            </Grid>*/}
                        </Grid>
                    </MuiBox>
                </MuiBox>
            </Container>
    );
}